module.exports = __webpack_public_path__ + "static/media/iconTableOfContent.5345b27e.svg";